module.exports = __webpack_public_path__ + "img/Weapon_251.860b50b1.png";